import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { UserSaved } from 'src/app/models/user.model';
import { WithholdingService } from 'src/app/services/withholding.service';
declare let $: any;

@Component({
  selector: 'app-automatic-withholdings',
  templateUrl: './automatic-withholdings.component.html',
  styleUrls: ['./automatic-withholdings.component.scss']
})
export class AutomaticWithholdingsComponent {
  upload = new ButtonLoading("btn-success", false, "CARGAR", "fa-upload");
  user: UserSaved = null;
  selected = false;
  selectedFile: File | null = null;

  constructor(
    private authService: AuthenticationService,
    private withholdingService: WithholdingService,
    private toastService: ToastrService,
  ) {
    this.user = this.authService.getUser();
  }

  
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    } else {
      this.selectedFile = null;
    }
  }

  uploadRegisters(): void {
    if (this.upload.loading || !this.selectedFile) {
      return;
    }

    this.upload.loading = true;

    this.withholdingService.uploadFile(this.selectedFile).subscribe({
      next: (response: any) => {
        this.upload.loading = false;
        this.toastService.success('¡Archivo procesado con éxito!');
      },
      error: (error: HttpErrorResponse) => {
        this.upload.loading = false;
        this.toastService.error(error.error.message || 'Error al procesar el archivo');
      },
    });
  }

}
